import { es, enGB, ca } from 'date-fns/locale';

export const AppLocales = { es: es, en: enGB, ca: ca };

export type LocaleKey = keyof typeof AppLocales;
